import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navRef = useRef(null);

  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleMenuClick = (e) => {
    // Close the menu if the click is inside the menu area but not on a nav item
    if (navRef.current && !navRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="mobile-menu-container" ref={menuRef}>
      <button
        className={`mobile-menu-button ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
      >
        <span className="hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
        <span className="exit-text">EXIT</span>
      </button>
      <div
        className={`mobile-menu ${isOpen ? 'open' : ''}`}
        onClick={handleMenuClick}
      >
        <nav ref={navRef}>
          <NavLink to="/" onClick={() => setIsOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setIsOpen(false)}>About</NavLink>
          <NavLink to="/tokenomics" onClick={() => setIsOpen(false)}>Tokenomics</NavLink>
          <NavLink to="/roadmap" onClick={() => setIsOpen(false)}>Roadmap</NavLink>
          <NavLink to="/traits-and-rarities" onClick={() => setIsOpen(false)}>Traits & Rarities</NavLink>
          <NavLink to="/search" onClick={() => setIsOpen(false)}>Search</NavLink>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;